import IndexPage from '../index';

export default IndexPage;
